<template>
  <div>
    <template v-for="(field, id) in fields">
      <ValueHelpWrapper
        v-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput v-else :key="id" v-bind="field" class="mb-2" />
    </template>
  </div>
</template>

<script>
import { tabelFilterFields } from './lib/tabelFilterFields'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'

export default {
  components: {
    ValueHelpWrapper,
  },
  props: {
    formValues: {},
    fullObjects: {},
  },
  data() {
    return {}
  },
  computed: {
    fields() {
      return tabelFilterFields(this)
    },
  },
}
</script>
